const axios = require('axios')
import * as Constants from "@/Constants";


export function fetchData (path, cb) {
  axios.get(path, Constants.getApiParam())
    .then(res => {
      cb(res.data)
    })
    .catch(error => {
      throw error
    })
}

